import { render } from "./ResetButton.vue?vue&type=template&id=5f05825d"
import script from "./ResetButton.vue?vue&type=script&lang=js"
export * from "./ResetButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__